import { Box, Divider, Heading } from '@hover/blueprint';
import React from 'react';
import FirstTeamValue from './FirstTeamValue';
import SecondTeamValue from './SecondTeamValue';
import ThirdTeamValue from './ThirdTeamValue';

interface Props {
  selectedValue: string;
  setSelectedValue: (value: string) => void;
}

const TeamValuesSectionMobile: React.FC<Props> = ({
  selectedValue,
  setSelectedValue,
}) => (
  <Box flexDir="column" display={{ base: 'block', tablet: 'none' }} px={200}>
    <Divider
      color="green.300"
      mb={{ base: 500, desktop: 800 }}
      borderWidth="1px"
    />
    <Heading
      onClick={() => setSelectedValue('think')}
      size={800}
      color={selectedValue === 'think' ? 'green.500' : 'green.100'}
    >
      Think.
    </Heading>
    <FirstTeamValue visible={selectedValue === 'think'} />
    <Divider color="green.300" my={500} borderWidth="1px" />
    <Heading
      onClick={() => setSelectedValue('do')}
      size={800}
      color={selectedValue === 'do' ? 'green.500' : 'green.100'}
    >
      Do.
    </Heading>
    <SecondTeamValue visible={selectedValue === 'do'} />
    <Divider color="green.300" my={500} borderWidth="1px" />
    <Heading
      onClick={() => setSelectedValue('serve')}
      size={800}
      color={selectedValue === 'serve' ? 'green.500' : 'green.100'}
    >
      Serve.
    </Heading>
    <ThirdTeamValue visible={selectedValue === 'serve'} />
    <Divider color="green.300" mt={500} mb={700} borderWidth="1px" />
  </Box>
);

export default TeamValuesSectionMobile;
